//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.Annotation.js";
let d=[[],[[[],"GetFileType",{R_:{filetype:''}},0,0],[["fileExist"],"ExportFile",{R_:{filename:''}},0,0]],[]];
SPLM.Annotations.DraftingImage = class extends SPLM.Annotations.Annotation{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.DraftingImage";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.DraftingImage.FileType = Object.freeze({
    "Png" : "Png", "Jpg" : "Jpg", "Tif" : "Tif"});

export default SPLM;